import { useGetCustomerByCustomerCodeQuery, useGetCustomerDetailQuery } from 'services/customer-lookup';

export function useCustomerDetail(customerId: number) {
  const { data: customerRes, isLoading } = useGetCustomerDetailQuery(customerId!, {
    skip: !customerId,
    refetchOnMountOrArgChange: true
  });

  return {
    customer: customerRes?.data,
    isLoading
  };
}

export function useCustomerDetailByCustomerCode(customerCode: string) {
  const { data: customerRes, isLoading } = useGetCustomerByCustomerCodeQuery(customerCode!, {
    skip: !customerCode,
    refetchOnMountOrArgChange: true
  });

  return {
    customer: customerRes?.data.rows[0],
    isLoading
  };
}
